import { render, staticRenderFns } from "./PemakaianKlaimDirektur.vue?vue&type=template&id=f29c7f3c&"
import script from "./PemakaianKlaimDirektur.vue?vue&type=script&lang=js&"
export * from "./PemakaianKlaimDirektur.vue?vue&type=script&lang=js&"
import style0 from "./PemakaianKlaimDirektur.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports